import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { ReportFacts } from '@backrs_ui/grow-ui/src/redux/satActBooster/satActBooster.types';

/** Grounds Lubav's turns in the computed score-report facts; a no-op until they exist. */
export const useReportFactsAgentContext = (reportFacts: ReportFacts | null) => {
  useRegisterAgentContext(
    reportFacts
      ? {
          kind: 'entity',
          description:
            'Computed ACT/SAT Test Booster score-report facts. These numbers are authoritative — present them verbatim in the report and never recompute or invent values.',
          data: { reportFacts },
        }
      : null,
  );
};
